<template>
    <div class="profile_wrap">
          <h5 class="uppercase underline">Reportar Nuevo Vehículo</h5>
          <form action="#" method="get">
            <div class="form-group">
              <label class="control-label">Marca</label>
              <div class="select">
                <select class="form-control white_bg">
                  <option>Seleccione</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">Modelo</label>
              <div class="select">
                <select class="form-control white_bg">
                  <option>Seleccione</option>
                </select>
              </div>
            </div>
            <div class="form-group">
              <label class="control-label">Linea</label>
              <div class="select">
                <select class="form-control white_bg">
                  <option>Seleccione</option>
                </select>
              </div>
            </div>
             <div class="form-group">
              <label class="control-label">Versión</label>
              <div class="select">
                <select class="form-control white_bg">
                  <option>Seleccione</option>
                </select>
              </div>
            </div>
             <div class="form-group">
              <label class="control-label">No. de propietarios</label>
              <input class="form-control white_bg" id="owners" type="text">
            </div>
            <div class="form-group">
              <label class="control-label">Kilometraje</label>
              <input class="form-control white_bg" id="kws" type="text">
            </div>
            <div class="form-group">
              <label class="control-label">Color</label>
              <input class="form-control white_bg" id="fuel" type="text">
            </div>
            <div class="form-group">
              <label class="control-label">Precio estimado ($)</label>
              <input class="form-control white_bg" id="Price" type="text">
            </div>
            <div class="form-group">
              <label class="control-label">Subir Imagenes</label>
              <div class="vehicle_images">
                <div><img src="assets/images/900x560.jpg" alt="image"></div>
                <div><img src="assets/images/900x560.jpg" alt="image"></div>
                <div class="upload_more_img">
                  <input name="upload" type="file">
                </div>
              </div>
            </div>   
            <div class="gray-bg field-title">
              <h6>Información Básica del Cliente</h6>
            </div>
            <div class="form-group">
              <label class="control-label">Nombre Completo</label>
              <input class="form-control white_bg" id="" type="text">
            </div>
            <div class="form-group">
              <label class="control-label">Celular</label>
              <input class="form-control white_bg" id="" type="text">
            </div>    
            <div class="form-group">
              <label class="control-label">Correo electrónico</label>
              <input class="form-control white_bg" id="" type="text">
            </div>   
             <div class="form-group">
              <label class="control-label">Ciudad</label>
              <input class="form-control white_bg" id="" type="text">
            </div>  
            <div class="form-group">
              <button type="submit" class="btn">Reportar Vehículo <span class="angle_arrow"><i class="fa fa-angle-right" aria-hidden="true"></i></span></button>
            </div>
          </form>
        </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>